import { addPersistentParamsToUrl } from '@/utils/persistentParams';
import Link, { LinkProps } from 'next/link';
import { CSSProperties, MouseEventHandler, ReactNode } from 'react';

type EnhancedLinkProps = Omit<LinkProps, 'href'> & {
  href: string;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

export const EnhancedLink = ({
  href,
  children,
  className,
  style,
  onClick,
  ...linkProps
}: EnhancedLinkProps) => {
  const enhancedHref = addPersistentParamsToUrl(href);

  return (
    <Link
      href={enhancedHref}
      className={className}
      style={style}
      onClick={onClick}
      {...linkProps}
    >
      {children}
    </Link>
  );
};
